<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                            v-model="search.vendor"
                            class="form-control border-0"
                            :options="optionVendor"
                            :customLabel="vendorLabel"
                            :show-labels="false"
                            placeholder="รหัสเจ้าหนี้"
                            track-by="name">
                    </multiselect>

                    <input
                            class="form-control mr-sm-2"
                            type="text"
                            v-model="search.amount"
                            placeholder="ยอดเงินจ่าย"/>
                    <date-picker
                            v-model="search.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            range
                            confirm
                            placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด" >
                    </date-picker>
                    &nbsp&nbsp
                    <select class="form-control" v-model="search.status">
                        <option disabled hidden value="" >ประเภทการจ่าย</option>
                        <option value="1">รอการชำระเงิน</option>
                        <option value="2">จ่ายเงินแล้ว</option>
                    </select>
                    &nbsp&nbsp
                    <button
                            class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchWaitingPayment">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รายการ</th>
                    <th scope="col">วันที่</th>
                    <th scope="col">รหัสผู้ขาย</th>
                    <th scope="col">ชื่อผู้ขาย</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">ผู้ตั้งเรื่อง</th>
                    <th scope="col">สถานะการชำระ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in paymentTable">
                    <td>{{++index}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <template v-if="data.vendor">
                            {{data.vendor.vendor_id}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.vendor">
                            {{data.vendor.name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{data.amount | currency }}</td>
                    <td>
                        <template v-if="data.user">
                            {{data.user.name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.status_id == 1">
                            <span style="color: red">{{data.status_name}}</span>
                        </template>
                        <template v-else>
                            <span style="color: green">{{data.status_name}}</span>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPage">
            </vue-pagination>
        </div>
        <!--<pre class="alert alert-danger">{{paymentTable}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";
    import Multiselect from "vue-multiselect";
    import VuePagination from "../../Pagination";

    export default {
        components: {
            VuePagination,
            DatePicker,
            Multiselect,
        },
        name: "waiting-payment",
        created(){
            this.$store.dispatch("WaitingPayment/setWaitingPayment");
            this.$store.dispatch("Vendor/getVendorAll")
        },
        data(){
            return{
                event_submit : false,
                page : 1,
                search:{
                    vendor: "",
                    amount: "",
                    date: [],
                    status: ""
                },
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        computed:{
            ...mapState({
                paymentTable : state=>{
                    return state.WaitingPayment.waiting_payment
                },
                optionVendor:state=>{
                    return state.Vendor.vendorAll;
                },
                dataPaginate : state=>{
                    return state.WaitingPayment.dataPaginate
                }
            })
        },
        methods:{
            vendorLabel (option) {
                return `${option.vendor_id} - ${option.name}`
            },
            searchWaitingPayment(){
                this.event_submit = true;
                let vendor_id = "";
                let start_date = "";
                let end_date = "";
                //change date format
                if(this.search.date.length > 0 && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                }else{
                    this.search.date = [];
                }
                if(this.search.vendor){
                    vendor_id = this.search.vendor.id;
                }
                let data = {
                    vendor_id: vendor_id,
                    amount: this.search.amount,
                    start_date : start_date,
                    end_date : end_date,
                    status: this.search.status
                };
                this.$store.dispatch("WaitingPayment/search",{
                    page : this.page,
                    data : data
                })
            },
            getPage(){
                this.page = this.dataPaginate.current_page
                if(this.event_submit){
                    this.searchWaitingPayment();
                }
                else{
                    this.$store.dispatch("WaitingPayment/setWaitingPayment",this.page);
                }
            }
        }
    }
</script>

<style scoped>

</style>